import React from "react";
import PropTypes from "prop-types";
import "./FormInputWithHeader.scss";

function FormInputWithHeader(props) {
  const { isBoldHeader, header, content } = props;
  const boldHeaderCls = isBoldHeader ? "bold" : "normal";
  return (
    <div className="form-input-with-header">
      <div className={`form-section-header ${boldHeaderCls}`}>{header}</div>
      <div className="form-section-content">{content}</div>
    </div>
  );
}

FormInputWithHeader.propTypes = {
  isBoldHeader: PropTypes.bool,
  header: PropTypes.string,
  content: PropTypes.any,
};

FormInputWithHeader.defaultProps = {
  isBoldHeader: true,
  header: "",
  content: "",
};

export default FormInputWithHeader;
